var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.44659 0.184985C4.69324 0.431632 4.69324 0.831526 4.44659 1.07817L2.15635 3.36842H12.4211C12.7699 3.36842 13.0526 3.65119 13.0526 4C13.0526 4.34881 12.7699 4.63158 12.4211 4.63158H2.15635L4.44659 6.92183C4.69324 7.16847 4.69324 7.56837 4.44659 7.81501C4.19995 8.06166 3.80005 8.06166 3.55341 7.81501L0.184985 4.44659C-0.0616617 4.19995 -0.0616617 3.80005 0.184985 3.55341L3.55341 0.184985C3.80005 -0.0616617 4.19995 -0.0616617 4.44659 0.184985Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left_arrow.977c6020dba36289b916eb7af2844fc4.svg";
export { ForwardRef as ReactComponent };